import React, { useContext, useEffect, useState } from 'react';
import DaumPostcode from 'react-daum-postcode';
import styled from 'styled-components';
import CustomModal from '../../components/modal/CustomModal';
import { AuthContext } from '../../navigation/AuthProvider';
import StoreController, { CurrentStoreContext } from '../../controller/StoreController';
import { useToast } from '../../controller/ToastController';
import { getNumberToString } from '../../utils/util';
import { useOutletContext } from 'react-router-dom';

const CeoInfo = () => {
  const [addressModal, setAddressModal] = useState<boolean>(false);
  const [storeOwner, setStoreOwner] = useState<string>('');
  const [sBusinessNm, setBusinessNm] = useState<string>('');
  const [sAddress, setAddress] = useState<string>('');
  const [sExtraAddress, setExAddress] = useState<string>('');
  const [sPhoneNm, setPhoneNm] = useState<string>('');

  const [sEmail, setEmail] = useState<string>('');
  const [accountBank, setAccountBank] = useState<string>('');
  const [accountNm, setAccountNm] = useState<string>('');

  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const showToast = useToast();

  // 다음주소검색
  const handleComplete = async (data: any) => {
    let fullAddress = data.address;
    let extraAddress = '';

    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname;
      }
      if (data.buildingName !== '') {
        extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
    }
    setAddress(fullAddress);
    setAddressModal(false);
  };
  const handleAddressModalClose = () => {
    setAddressModal(false);
  };

  // onChange
  const onChange_name = (event: any) => {
    setStoreOwner(event.target.value);
  };
  const onChange_businessNumber = (event: any) => {
    setBusinessNm(getNumberToString(event.target.value));
  };
  const onChange_sAddress = (event: any) => {
    setAddress(event.target.value);
  };
  const onChange_sExtraAddress = (event: any) => {
    setExAddress(event.target.value);
  };
  const onChange_phoneNumber = (event: any) => {
    setPhoneNm(getNumberToString(event.target.value));
  };
  const onChange_email = (event: any) => {
    setEmail(event.target.value);
  };
  const onChange_accountBank = (event: any) => {
    setAccountBank(event.target.value);
  };
  const onChange_accountNumber = (event: any) => {
    setAccountNm(getNumberToString(event.target.value));
  };

  // 필수 확인
  const checkRequired = () => {
    if (
      storeOwner.length > 0 &&
      sBusinessNm.length > 9 &&
      sAddress.length > 0 &&
      sExtraAddress.length > 0 &&
      sPhoneNm.length > 8 &&
      sEmail.length > 6 &&
      accountBank.length > 0 &&
      accountNm.length > 9
    )
      return true;
    return false;
  };

  // API 불러오기
  const getMerchant = async () => {
    try {
      const oRes: any = await StoreController.getMerchant(currentStore.value);
      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getMerchant', oResponse);
        if (oResponse.data) {
          setStoreOwner(oResponse.data.full_name);
          setPhoneNm(oResponse.data.phone_number);
          setAddress(oResponse.data.address1);
          setExAddress(oResponse.data.address2);
          setBusinessNm(oResponse.data.business_number);
          setEmail(oResponse.data.email);
          setAccountBank(oResponse.data.bank_name);
          setAccountNm(oResponse.data.account_nm);
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  const setMerchant = async () => {
    try {
      const merchant = {
        full_name: storeOwner,
        business_number: sBusinessNm,
        address1: sAddress,
        address2: sExtraAddress,
        phone_number: sPhoneNm,
        email: sEmail,
        bank_name: accountBank,
        account_nm: accountNm,
        account_holder: storeOwner,
      };
      if (checkRequired()) {
        const oRes: any = await StoreController.setMerchant(currentStore.value, merchant);

        if (oRes && oRes.data) {
          const oResponse = oRes.data;
          if (oResponse.ok) {
            showToast('사장님정보를 변경했어요.');
          }
        }
      } else {
        showToast('필수 정보를 입력해주세요.', 'error');
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  useEffect(() => {
    getMerchant();
  }, [currentStore]);

  return (
    <>
      <Style>
        <div className="contentContainer">
          <h2>사업자 정보</h2>
          <div className="inputText">
            <div className="row">
              <h2>대표자명</h2>
              <span>(필수)</span>
            </div>
            <input
              type="text"
              // placeholder="사업자 등록증상의 대표명과 동일해야 합니다."
              value={storeOwner}
              onChange={onChange_name}
            />
          </div>
          <div className="inputText">
            <div className="row">
              <h2>사업자번호</h2>
              <span>(필수)</span>
            </div>
            <input
              type="text"
              placeholder="- 를 제외하고 입력해주세요"
              maxLength={10}
              value={sBusinessNm}
              onChange={onChange_businessNumber}
            />
          </div>
          <div className="inputText">
            <div className="row">
              <h2>사업장 소재지</h2>
              <span>(필수)</span>
            </div>
            <div className="address">
              <input
                type="text"
                disabled
                value={sAddress}
                placeholder="도로명 주소를 입력해주세요."
                style={{ marginBottom: '8px', backgroundColor: '#ffffff' }}
              />
              <button
                className="searchBox"
                onClick={() => {
                  setAddressModal(true);
                }}>
                <img src={`${process.env.PUBLIC_URL}/svg/ic_search.svg`} alt="search" />
              </button>
            </div>
            <input
              type="text"
              placeholder="상세주소를 입력해주세요"
              value={sExtraAddress}
              onChange={onChange_sExtraAddress}
            />
          </div>
          <div className="inputText">
            <div className="row">
              <h2>대표자 전화번호</h2>
              <span>(필수)</span>
            </div>
            <input
              type="text"
              placeholder="- 를 제외하고 입력해주세요"
              value={sPhoneNm}
              maxLength={11}
              onChange={onChange_phoneNumber}
            />
          </div>
        </div>
        <div className="contentContainer">
          <h2>계좌 정보</h2>
          <div className="inputText">
            <div className="row">
              <h2>이메일</h2>
              <span>(필수)</span>
            </div>
            <input
              type="text"
              // placeholder="사업자 등록증상의 대표명과 동일해야 합니다."
              value={sEmail}
              onChange={onChange_email}
            />
          </div>
          <div className="inputText">
            <div className="row">
              <h2>입금은행</h2>
              <span>(필수)</span>
            </div>
            <input
              type="text"
              // placeholder="사업자 등록증상의 대표명과 동일해야 합니다."
              value={accountBank}
              onChange={onChange_accountBank}
            />
          </div>
          <div className="inputText">
            <div className="row">
              <h2>계좌번호</h2>
              <span>(필수)</span>
            </div>
            <input
              type="text"
              placeholder="- 를 제외하고 입력해주세요"
              value={accountNm}
              onChange={onChange_accountNumber}
              maxLength={14}
            />
          </div>
          <button
            className={`submitButton ${!checkRequired() && 'inactive'}`}
            onClick={setMerchant}>
            등록하기
          </button>
        </div>
      </Style>
      {/* <Toaster /> */}
      <CustomModal isVisible={addressModal} setVisible={setAddressModal}>
        <div style={{ display: 'flex' }}>
          <button
            onClick={handleAddressModalClose}
            style={{ marginLeft: 'auto', marginRight: '1%' }}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`} alt="ic" />
          </button>
        </div>
        <DaumPostcode
          onComplete={handleComplete}
          onClose={handleAddressModalClose}
          autoClose
          style={{ height: '54vh' }}
        />
      </CustomModal>
    </>
  );
};
export default CeoInfo;

const Style = styled.div`
  .contentContainer:nth-child(1) {
    border-radius: 10px 10px 0 0;
  }
  .contentContainer:nth-child(2) {
    border-radius: 0 0 10px 10px;
  }
  h2 {
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
  }

  .inputText {
    .row {
      margin: 30px 0 6px 0;
      display: flex;
      align-items: center;
      gap: 4px;

      span {
        font-size: 14px;
        line-height: 20px;
        color: #40977f;
      }
      h2 {
        font-weight: 700px;
      }
    }

    input {
      width: 100%;
      padding: 10px 12px;
      border: 1px solid #cecece;
      border-radius: 5px;
    }
  }

  /* 주소검색 */
  .address {
    position: relative;

    .searchBox {
      margin-bottom: 8px;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      padding: 10px 20px;
      border: none;
      background: #4dd2ae;
      color: #fff;
      border-radius: 5px;
      cursor: pointer;
      font-size: 16px;
      font-weight: 700;
      display: flex;
      align-items: center;
    }
  }
`;
